"use client";
import { useId as o } from "react";
const s = (e = "fe") => {
  const t = o();
  return `${e}-${t}`;
};
export {
  s as useFeId
};
